import _ from 'lodash';

/* DX extracted code */
const bracketsToDots = function(expr) {
	return expr.replace(/\[/g, ".").replace(/\]/g, "")
}

const prepareOptions = function(options) {
	options = options || {};
	options.unwrapObservables = void 0 !== options.unwrapObservables ? options.unwrapObservables : true;
	return options
}

function unwrap(value) {
	return value;
}

function _typeof(obj) {
	return typeof obj;
}

function _isConjunctiveOperator(condition) {
	return /^(and|&&|&)$/i.test(condition);
}

function _normalizeBinaryCriterion(crit) {
	return [crit[0], crit.length < 3 ? "=" : String(crit[1]).toLowerCase(), crit.length < 2 ? true : crit[crit.length - 1]];
}

const types = {
	"[object Array]": "array",
	"[object Date]": "date",
	"[object Object]": "object",
	"[object String]": "string",
	"[object Null]": "null"
}

const type = function(object) {
	var typeOfObject = Object.prototype.toString.call(object);
	return "object" === _typeof(object) ? types[typeOfObject] || "object" : _typeof(object)
}

function toComparable(value, caseSensitive) {
	if (value instanceof Date) {
		return value.getTime()
	}
	if (!caseSensitive && "string" === typeof value) {
		return value.toLowerCase()
	}
	return value
}

function isGroupOperator(value) {
	return "and" === value || "or" === value
}

function _isGroupCriterion(crit) {
	var first = crit[0];
	var second = crit[1];
	if (Array.isArray(first)) {
		return true
	}
	if ((0, _type.isFunction)(first)) {
		if (Array.isArray(second) || (0, _type.isFunction)(second) || isGroupOperator(second)) {
			return true
		}
	}
	return false
}

function _isUnaryOperation(crit) {
	return "!" === crit[0] && Array.isArray(crit[1])
}

function combineGetters(getters) {
	var compiledGetters = {};
	for (var i = 0, l = getters.length; i < l; i++) {
		var getter = getters[i];
		compiledGetters[getter] = compileGetter(getter)
	}
	return function(obj, options) {
		var result;
		(0, _iterator.each)(compiledGetters, function(name) {
			var value = this(obj, options);
			if (void 0 === value) {
				return
			}
			var current = result || (result = {});
			var path = name.split(".");
			var last = path.length - 1;
			for (var _i = 0; _i < last; _i++) {
				var pathItem = path[_i];
				if (!(pathItem in current)) {
					current[pathItem] = {}
				}
				current = current[pathItem]
			}
			current[path[last]] = value
		});
		return result
	}
}

function compileGetter(expr) {
	if (arguments.length > 1) {
		expr = [].slice.call(arguments)
	}
	if (!expr || "this" === expr) {
		return function(obj) {
			return obj
		}
	}
	if ("string" === typeof expr) {
		expr = bracketsToDots(expr);
		var path = expr.split(".");
		return function(obj, options) {
			options = prepareOptions(options);
			var functionAsIs = options.functionsAsIs;
			var hasDefaultValue = "defaultValue" in options;
			var current = unwrap(obj, options);
			for (var i = 0; i < path.length; i++) {
				if (!current) {
					if (null == current && hasDefaultValue) {
						return options.defaultValue
					}
					break
				}
				var pathPart = path[i];
				if (hasDefaultValue && (0, _type.isObject)(current) && !(pathPart in current)) {
					return options.defaultValue
				}
				var next = unwrap(current[pathPart], options);
				if (!functionAsIs && (0, _type.isFunction)(next)) {
					next = next.call(current)
				}
				current = next
			}
			return current
		}
	}
	if (Array.isArray(expr)) {
		return combineGetters(expr)
	}
	if ((0, _type.isFunction)(expr)) {
		return expr
	}
}

const compileCriteria = function() {
	var compileGroup = function(crit) {
		var ops = [];
		var isConjunctiveOperator = false;
		var isConjunctiveNextOperator = false;
		(0, _iterator.each)(crit, function() {
			if (Array.isArray(this) || (0, _type.isFunction)(this)) {
				ops.push(compileCriteria(this));
				isConjunctiveOperator = isConjunctiveNextOperator;
				isConjunctiveNextOperator = true
			} else {
				isConjunctiveNextOperator = _isConjunctiveOperator(this)
			}
		});
		return function(d) {
			var result = isConjunctiveOperator;
			for (var i = 0; i < ops.length; i++) {
				if (ops[i](d) !== isConjunctiveOperator) {
					result = !isConjunctiveOperator;
					break
				}
			}
			return result
		}
	};
	var toString = function(value) {
		return (0, _type.isDefined)(value) ? value.toString() : ""
	};
	var compileBinary = function(crit) {
		crit = _normalizeBinaryCriterion(crit);
		var getter = (0, compileGetter)(crit[0]);
		var op = crit[1];
		var value = crit[2];
		value = (0, toComparable)(value);
		switch (op.toLowerCase()) {
			case "=":
				return compileEquals(getter, value);
			case "<>":
				return compileEquals(getter, value, true);
			case ">":
				return function(obj) {
					return (0, toComparable)(getter(obj)) > value
				};
			case "<":
				return function(obj) {
					return (0, toComparable)(getter(obj)) < value
				};
			case ">=":
				return function(obj) {
					return (0, toComparable)(getter(obj)) >= value
				};
			case "<=":
				return function(obj) {
					return (0, toComparable)(getter(obj)) <= value
				};
			case "startswith":
				return function(obj) {
					return 0 === (0, toComparable)(toString(getter(obj))).indexOf(value)
				};
			case "endswith":
				return function(obj) {
					var getterValue = (0, toComparable)(toString(getter(obj)));
					var searchValue = toString(value);
					if (getterValue.length < searchValue.length) {
						return false
					}
					return getterValue.lastIndexOf(value) === getterValue.length - value.length
				};
			case "contains":
				return function(obj) {
					return (0, toComparable)(toString(getter(obj))).indexOf(value) > -1
				};
			case "notcontains":
				return function(obj) {
					return (0, toComparable)(toString(getter(obj))).indexOf(value) === -1
				}
		}
	};

	function compileEquals(getter, value, negate) {
		return function(obj) {
			obj = (0, toComparable)(getter(obj));
			var result = useStrictComparison(value) ? obj === value : obj == value;
			if (negate) {
				result = !result
			}
			return result
		}
	}

	function useStrictComparison(value) {
		return "" === value || 0 === value || false === value
	}

	function compileUnary(crit) {
		var op = crit[0];
		var criteria = compileCriteria(crit[1]);
		if ("!" === op) {
			return function(obj) {
				return !criteria(obj)
			}
		}
	}
	return function(crit) {
		if ((0, _type.isFunction)(crit)) {
			return crit
		}
		if (_isGroupCriterion(crit)) {
			return compileGroup(crit)
		}
		if (_isUnaryOperation(crit)) {
			return compileUnary(crit)
		}
		return compileBinary(crit)
	}
}();

const _type = {
	isFunction: function(object) {
		return "function" === typeof object
	},
	isObject: function(object) {
		return "object" === type(object)
	},
	isDefined: function(object) {
		return null !== object && void 0 !== object
	}
}

const _iterator = {
	map: function(values, callback) {
		if (Array.isArray(values)) {
			return values.map(callback)
		}
		var result = [];
		for (var key in values) {
			result.push(callback(values[key], key))
		}
		return result
	},
	each: function(values, callback) {
		if (!values) {
			return
		}
		if ("length" in values) {
			for (var i = 0; i < values.length; i++) {
				if (false === callback.call(values[i], i, values[i])) {
					break
				}
			}
		} else {
			for (var key in values) {
				if (false === callback.call(values[key], key, values[key])) {
					break
				}
			}
		}
		return values
	},
	reverseEach: function(array, callback) {
		if (!array || !("length" in array) || 0 === array.length) {
			return
		}
		for (var i = array.length - 1; i >= 0; i--) {
			if (false === callback.call(array[i], i, array[i])) {
				break
			}
		}
	}
}

/* Main array operations funcs */

async function sortDataSource(array, sortings) {
	return _.orderBy(array, sortings.map(f => f.field), sortings.map(f => f.desc ? 'desc' : 'asc'));
}

async function filterDataSource(array, filter) {
	if (!filter?.length) return array;
	const checkCriteria = compileCriteria(filter);
	return array.filter(f => checkCriteria(f));
}

async function groupDataSource(array, groups, aggregates, aggregationType, delimeter) {
	aggregationType = aggregationType || 'sum';

	const groupedData = _.groupBy(array, v => groups.length ? JSON.stringify(groups.map(f => v[f])) : '{}');
	const result = [];
	Object.keys(groupedData).map(key => {
		const groupVals = JSON.parse(key);
		const groupItems = groupedData[key];

		const currentRow = {};
		groups.map((g, gIdx) => currentRow[g] = groupVals[gIdx]);

		(aggregates || []).map(f => {
			switch(aggregationType) {
				case 'sum':
					currentRow[f] = groupItems.reduce((res, it) => { 
						if (!it[f]) return res;
						if (isNaN(it[f])) {
							//For strings need to concat
							if (`${(res || '')}`.indexOf(it[f]) === -1) {
								res = `${(res || '')}${(res || '') ? (delimeter || ', ') : ''} ${it[f]}`;
							}
						} else {
							res += it[f]
						}

						return res;
					} , 0);
					break;
				case 'max': {
					const maxItem = _.maxBy(groupItems, f);
					currentRow[f] = maxItem && maxItem[f];
					break;
				}
				case 'min': {
					const minItem = _.minBy(groupItems, f);
					currentRow[f] = minItem && minItem[f];
					break;
				}
				case 'avg': {
					currentRow[f] = _.sumBy(groupItems, f) / groupItems.length;
					break;
				}
				case 'count': {
					currentRow[f] = groupItems.length;
					break;
				}
			}
		});

		result.push(currentRow);
	});

	return result;
}

/* List options/phrase funcs */

async function processListOptions(array, listOptions) {
	if (!listOptions.phrases?.length) return;

	if (__DEBUG__)
		console.debug('processListOptions', { array, listOptions });

	return listOptions.phrases?.length && (await Promise.all(listOptions.phrases.map(async phrase => {
		return await processPhrase(array, phrase);
	}))).filter(f => f).join('. ');
}

async function processPhrase(array, phrase) {
	if (!phrase) return;

	if (__DEBUG__)
		console.debug('processListOptions', { array, phrase });
	
	let phraseArray = array;

	for(let i = 0; i < phrase.operations.length; i++) {
		let op = phrase.operations[i];

		switch(op.operation) {
			case 'sort':
				phraseArray = await sortDataSource(phraseArray, op.fields.map(f => ({ field: f, desc: op.direction === 'desc' })));
				break;
			case 'group':
				phraseArray = await groupDataSource(phraseArray, op.dimensions, op.aggregations, op.aggregationType, phrase.itemDelimeter);
				break;
			case 'filter':
				phraseArray = await filterDataSource(phraseArray, op.filter);
				break;
			case 'take':
				phraseArray = phraseArray.slice(0, op.value);
				break;
			case 'skip':
				phraseArray = phraseArray.slice(op.value, phraseArray.length);
				break;
		}

		if (__DEBUG__)
			console.debug('Apply operation', op.operation, phraseArray);
	}

	let items = [];
	if (phrase.itemTemplate) {
		items = phraseArray.map(row => {
			let itemResult = phrase.itemTemplate;
			Object.keys(row).map(field => {
				itemResult = itemResult.replace(new RegExp(`@${field}`, 'gi'), row[field]);
			});
			return itemResult;
		});
	}

	return (phrase.phraseTemplate || '').replace(/\[ITEMS\]/gi, items.join(phrase.itemDelimeter || ' '));
}

export {
	processListOptions,
	processPhrase,
	filterDataSource,
	groupDataSource,
	sortDataSource,
	compileCriteria
}

export default {
	processListOptions,
	processPhrase,
	filterDataSource,
	groupDataSource,
	sortDataSource,
	compileCriteria
}